import toast from "react-hot-toast";
import { oidcClient } from "../redux/token";

/**
 * Hook designed to fetch and display data about a recommendation/client business sheet
 * Primarily designed to get the PDF consent, etc and preview business sheets for compliance purposes
 */

type useBusinessSheetDataOptions = {
    getPdfBytes: () => Promise<string>
};

// TODO: get the instruction and new money errors to display?
type BusinessSheetPdfResponse = {
    isValid: boolean,
    pdfData: string
};

export const useBusinessSheetData = (businessSheetId: string | null | undefined) : useBusinessSheetDataOptions => {
    
    const handleGetPdfBytes = () : Promise<string> => toast.promise(new Promise<string>((r, e) => {
        if (!businessSheetId) {
            e('Business Sheet does not exist or is not available.');
        }

        let tokenData = oidcClient.getOidcToken();
        fetch(`/api/recommendations/BusinessSheet/${businessSheetId}/Pdf`, {
            method: 'GET',
            headers: {
                'Authorization': `${tokenData?.token_type} ${tokenData?.access_token}`,
                'Content-Type': 'application/json'
            }
        })
        .then((response) => response.json())
        .then((data: BusinessSheetPdfResponse) => {
            if (!data.isValid) {
                e('Could not open business sheet because it contains errors. Please go and fix the business sheet.');
                return;
            }
            r(data.pdfData);
        })
        .catch((error) => {
            e(error)
        })
    }), {
        loading: 'Downloading Business Sheet...',
        success: `Business Sheet was downloaded successfully.`,
        error: (e) => {
            if (e && typeof(e) === 'string') {
                return e;
            }
            return 'Failed to fetch the Business Sheet.';
        }
    });
    
    return { 
        getPdfBytes: handleGetPdfBytes
    }
};